import { useState } from 'react';
import { mui } from '~/tools/mui';
import { jss } from '~/tools/jss';
import { useTranslation } from '~/behaviors';
import { icons } from '~/tools/icons';

const useStyles = jss.makeStyles((theme) => ({
  title: {
    fontWeight: 'bold',
  },
  alert: {
    '& .MuiAlert-message': {
      maxWidth: '90%',
    },
  },
  close: {
    position: 'absolute',
    top: '0px',
    right: '10px',
    textTransform: 'uppercase',
    '&:hover': {
      fontWeight: 'bold',
      cursor: 'pointer',
    },
  },
}));

type TipInput = {
  title: string;
  text: string;
  onDismiss: Function;
};

/**
 * @component InformationTip
 *
 * @param {string} [title] - if defined, will be displayed in AlertTitle above content
 * @param {string} [text] - content of this informational tip
 * @param {function} [onDismiss] -  will be caleld if/when the user dismisses this informational tip
 *
 */
const InformationBox = ({ title, text, onDismiss }: TipInput) => {
  const { t } = useTranslation();
  const styles = useStyles();

  const [isVisible, setIsVisible] = useState(true);

  const handleClickDismiss = () => {
    setIsVisible(false);
    onDismiss();
  };

  return (
    <mui.Collapse in={isVisible}>
      <mui.Alert variant="filled" severity="success" className={styles.alert} icon={<icons.InfoOutlinedIcon />}>
        <div className={styles.close} onClick={handleClickDismiss}>
          <p>{t('dismiss')}</p>
        </div>
        <mui.AlertTitle className={styles.title}>{title}</mui.AlertTitle>
        {text}
      </mui.Alert>
    </mui.Collapse>
  );
};

export default InformationBox;
